<div
  gapTextPlaceholder
  [innerHTML]="(_question$ | async)!.value | displayMath"
></div>
